import axios from '../api/index'
export const setEmail = async (email) =>{
    const data = {"email":email}
    const emailSent = await axios.requestData('post','/config/email',data)
    return emailSent.data
}